/**
 * What the intensity panel edits, as a snapshot its undo history can hold: every part's
 * arrangement fields and its own instrument and rhythm, and the song's rhythm and instrument.
 * Nothing else, so undoing a level never takes back a lyric or a chart.
 */

/** The fields on a part the intensity panel sets, all absent at their defaults */
export const ARRANGE_FIELDS = [
  'chartIntensity',
  'chartIntensityPasses',
  'chartBuild',
  'chartFill',
  'chartDrop',
  'chartPad',
  'chartLayers',
  'chartInstrumentId',
  'chartRhythm',
];

const pickArrangement = (part) =>
  Object.fromEntries(ARRANGE_FIELDS.filter((field) => part[field] !== undefined).map((field) => [field, part[field]]));

/** The arrangement of a song's form data, keyed by part id */
export const getArrangement = ({ parts = [], chartRhythm = null, chartInstrumentId = null } = {}) => ({
  parts: Object.fromEntries(parts.map((part) => [part.id, pickArrangement(part)])),
  chartRhythm: chartRhythm ?? null,
  chartInstrumentId: chartInstrumentId ?? null,
});

/**
 * The form data with an arrangement put back. A part the snapshot doesn't know, added since, keeps
 * its own; one deleted since stays deleted.
 */
export const applyArrangement = (data, { parts, chartRhythm, chartInstrumentId }) => ({
  ...data,
  chartRhythm,
  chartInstrumentId,
  parts: data.parts.map((part) => {
    if (!parts[part.id]) return part;

    const rest = { ...part };

    ARRANGE_FIELDS.forEach((field) => delete rest[field]);

    return { ...rest, ...parts[part.id] };
  }),
});
